import classes from './HealthCare.module.scss'
import React, {useEffect} from 'react';
import Heading from "../../components/services/heading/Heading.tsx";
import BlackCardWithIcon from "../../components/black-card-with-icon/BlackCardWithIcon.tsx";
import GrayCardBlueIcon from "../../components/gray-card-blue-icon/GrayCardBlueIcon.tsx";
import BlueGradientBlock from "../../components/blue-gradient-block/BlueGradientBlock.tsx";
import GrayCardWithVerticalDivider
    from "../../components/gray-card-with-vertical-divider/GrayCardWithVerticalDivider.tsx";
import FormCard from "../../components/formCard/FormCard.tsx";
import {Link} from "react-scroll";
import eRoadImg from '../../media/projects/e-road.webp'
import {Helmet} from "react-helmet-async";
import { useTranslation } from 'react-i18next';

const Healthcare = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const { t } = useTranslation();
        
    const title = t('healthcare.title')
    const description = t('healthcare.text', {returnObjects: true})

    const blackBlocks = t('healthcare.blackBlocks', {returnObjects: true})

    const challengesBlocks = t('healthcare.challengesBlocks', {returnObjects: true})

    const solutionsBlocks= t('healthcare.solutionsBlocks', {returnObjects: true})

    const benefitBlocks= t('healthcare.benefitBlocks', {returnObjects: true})

    const stories = t('healthcare.stories', {returnObjects: true})



    return (
        <>
            <Helmet>
                <title>Healthcare Software Development & IT Solutions | HealthTech Systems – Goteco</title>
                <meta
                    name="description"
                    content="Custom healthcare software development for hospitals, clinics, and healthtech startups. Build EHR systems, telemedicine platforms, and healthcare analytics solutions with Goteco."
                />
                <link rel="canonical" href="https://go-te.co/industries/healthcare"/>
            </Helmet>

            <main>
                <Heading title={title} description={description} maxWidth={680}/>

                <section className={`section--white ${classes['digital-transformation']}`} id={"nav-dark"}>
                    <div>
                        <h3>{t('healthcare.blackBlocksTitle')}</h3>
                        <p>
                            {t('healthcare.blackBlocksText')}</p>
                    </div>
                    <div className={classes.blocks}>
                        {blackBlocks.map(({text, icon, title}) => (
                            <BlackCardWithIcon key={icon} iconName={icon} text={text} title={title}/>
                        ))}
                    </div>
                </section>

                <section className={`section--dark-gray ${classes['key-challenges']}`} id={"nav-light"}>
                    <div>
                        <h2>{t('healthcare.challengesBlocksTitle')}</h2>
                    </div>
                    <div>
                        {challengesBlocks.map(({icon, text, title}) => (
                            <GrayCardBlueIcon
                                iconName={icon}
                                title={title}
                                text={text}
                                key={title}
                            />
                        ))}
                    </div>
                </section>

                <section className={`section--white ${classes['solutions']}`} id={"nav-dark"}>
                    <div>
                        <h2>{t('healthcare.solutionsBlocksTitle')}</h2>
                    </div>
                    <div>
                        {solutionsBlocks.map(({image, title, text}) => (
                            <div className={classes.block} key={title}>
                                <img alt={title} src={require(`./media/${image}`)}/>
                                <div className={classes.content}>
                                    <h5>{title}</h5>
                                    <p>{text}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </section>

                <section className={`section--light-gray ${classes['benefits']}`} id={"nav-dark"}>
                    <div>
                        <h2>{t('healthcare.benefitBlocksTitle')}</h2>
                    </div>
                    <div>
                        {benefitBlocks.map(({title, text}) => (
                            <BlueGradientBlock title={title} text={text} key={title}/>
                        ))}
                    </div>
                </section>

                <section className={"section--dark-gray " + classes['stories']}>
                    <h2>{t('healthcare.storiesTitle')}</h2>
                    <div className={classes.blocks}>
                        {stories.map(({title, text}) => (
                            <GrayCardWithVerticalDivider title={title} text={text} key={title}/>
                        ))}
                    </div>
                </section>

                <section className={`section--dark-gray ${classes['use-case']}`} id={"nav-light"}>
                    <div className={classes.content}>
                        <div className={classes['text-block']}>
                            <h2>{t('healthcare.useCase')}</h2>
                            <div className={classes.text}>
                                <img src={eRoadImg} alt="Healthcare use case"/>
                                <p>
                                    {t('healthcare.useCaseSubtitle')}</p>
                            </div>
                        </div>
                        <div className={classes.actions}>
                            <span>{t('healthcare.useCaseText')}</span>
                            <Link className={classes.link} smooth={true} to={'contact'}>
                                {t('healthcare.useCaseButton')}
                            </Link>
                        </div>
                    </div>
                    <img className={classes.img} src={eRoadImg} alt="Healthcare system"/>
                </section>

                <section className="section--white" id="nav-dark">
                    <FormCard
                        title={t('healthcare.formCard.title')}
                        message={t('healthcare.formCard.message')}
                        buttonText={t('healthcare.formCard.buttonText')}
                        labels={t('healthcare.formCard.labels', {returnObjects: true})}
                        top={3}
                        id='contact'
                    />
                </section>
            </main>
        </>
    );
};

export default Healthcare;